import { combineReducers } from 'redux';

import { baseApi } from '../apis/baseApi';

import authReducer from './authReducer';
import browseReducer from './browseReducer';
import companyProfileReducer from './companyProfileReducer';
import dashboardReducer from './dashboardReducer';
import disputesReducer from './disputesReducer';
import filtersReducer from './filtersReducer';
import globalReducer from './globalReducer';
import integrationReducer from './integrationReducer';
import linkedInImportReducer from './linkedInImportReducer';
import networkReducer from './networkReducer';
import notificationReducer from './notificationReducer';
import organizationsReducer from './organizationsReducer';
import paymentsReducer from './paymentsReducer';
import referRequestReducer from './referRequestReducer';
import skillsReducer from './skillsReducer';
import stepsReducer from './stepsReducer';
import strengthenQuestionReducer from './strengthenQuestionReducer';
import stripeReducer from './stripeReducer';
import unsubscribeReducer from './unsubscribeReducer';
import userReducer from './userReducer';

const appReducer = combineReducers({
  authReducer,
  disputesReducer,
  globalReducer,
  organizationsReducer,
  paymentsReducer,
  stripeReducer,
  userReducer,
  integrationReducer,
  networkReducer,
  filtersReducer,
  linkedInImportReducer,
  browseReducer,
  strengthenQuestionReducer,
  skillsReducer,
  notificationReducer,
  companyProfileReducer,
  dashboardReducer,
  stepsReducer,
  referRequestReducer,
  unsubscribeReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

export const rootReducer = (state, action) => appReducer(state, action);
